import { render } from "./PrivacyEn.vue?vue&type=template&id=3f1647d2"
import script from "./PrivacyEn.vue?vue&type=script&lang=js"
export * from "./PrivacyEn.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__